"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreInfoIcon = exports.MoreInfoIconSection = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const StyledIcon = (0, styled_components_1.default)(base_react_components_1.Icon).withConfig({ displayName: "reports-StyledIcon", componentId: "reports-1xlz4lo" }) `
  color: ${base_react_components_1.theme.navBlue};
  cursor: pointer;
`;
const TitleWrapper = styled_components_1.default.div.withConfig({ displayName: "reports-TitleWrapper", componentId: "reports-1hldbb0" }) `
  & > ${base_react_components_1.Divider} {
    margin-top: 8px;
  }
`;
const ChildrenContainer = styled_components_1.default.div.withConfig({ displayName: "reports-ChildrenContainer", componentId: "reports-6gsrc2" }) `
  padding-top: 16px;
  padding-bottom: 32px;
`;
const InformationSection = styled_components_1.default.div.withConfig({ displayName: "reports-InformationSection", componentId: "reports-83rbne" }) ``;
const Label = (0, styled_components_1.default)(base_react_components_1.Copy).attrs({ bold: true }).withConfig({ displayName: "reports-Label", componentId: "reports-1sq2vdx" }) ``;
const MoreInfoIconSection = ({ label, copy, children, }) => (react_1.default.createElement(InformationSection, null,
    react_1.default.createElement(Label, null, label),
    react_1.default.createElement(base_react_components_1.Copy, null, copy),
    children));
exports.MoreInfoIconSection = MoreInfoIconSection;
const MoreInfoIconComponent = (0, styled_components_1.default)((_a) => {
    var { title, children } = _a, props = __rest(_a, ["title", "children"]);
    const { setInfoDrawer } = (0, base_react_components_1.useInfoDrawer)();
    const openDrawer = () => setInfoDrawer({
        isOpen: true,
        title: (react_1.default.createElement(TitleWrapper, null,
            title,
            react_1.default.createElement(base_react_components_1.Divider, null))),
        content: react_1.default.createElement(ChildrenContainer, null, children),
    });
    return (react_1.default.createElement(StyledIcon, Object.assign({ name: "actions/circle-faq", color: base_react_components_1.theme.navBlue, fill: base_react_components_1.theme.navBlue, onClick: openDrawer }, props)));
}).withConfig({ displayName: "reports-MoreInfoIconComponent", componentId: "reports-6308y1" }) ``;
exports.MoreInfoIcon = Object.assign(MoreInfoIconComponent, { Section: exports.MoreInfoIconSection });
exports.default = exports.MoreInfoIcon;
//# sourceMappingURL=index.js.map